import { Text } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { BaseNode, formatFieldLabel, nodePropsAreEqual } from './BaseNode'

export interface DefaultNodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void

  showDeleteButton?: boolean
}

const DefaultNodeComponent: React.FC<DefaultNodeProps> = ({
  data,
  onDelete,
  onDeleteNode,
  id,
  showDeleteButton,
}) => {
  const t = useSwitchboardT()
  const nodeData = data as Record<string, unknown> & { label?: string }
  const defaultLabel = text(t, 'switchboard.nodes.defaultLabel', 'Node')

  // Filter out label and get meaningful data fields
  const dataFields = Object.entries(nodeData)
    .filter(([key]) => key !== 'label')
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== '',
    )

  return (
    <BaseNode
      badgeColor="blue"
      label={nodeData.label || defaultLabel}
      showPlaceholder={dataFields.length === 0}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
    >
      {dataFields.map(([key, value]) => (
        <Text key={key} fontSize="sm" wordBreak="break-word">
          {formatFieldLabel(key)}: {String(value)}
        </Text>
      ))}
    </BaseNode>
  )
}

export const DefaultNode = React.memo(DefaultNodeComponent, nodePropsAreEqual)
